/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PipelineEntityFilterMode } from './pipelineEntityFilterMode';
import type { PipelineEntityFilterScope } from './pipelineEntityFilterScope';

/**
 * A company or university chip from the filter panel.
 *
 * Carries the same knobs as the talent-search card it mirrors: exclude,
 * require, tenure scope, and an optional date window. ``text`` is matched as a
 * case-insensitive substring, so a hand-typed name works exactly like a picked
 * autocomplete suggestion — the panel never blocks a name we have no
 * suggestion for.
 */
export interface PipelineEntityFilter {
  /**
     * @minLength 1
     * @maxLength 200
     */
  text: string;
  mode?: PipelineEntityFilterMode;
  required?: boolean;
  scope?: PipelineEntityFilterScope;
  from_date?: string | null;
  to_date?: string | null;
}
